"use client"

import styled from "@emotion/styled"
import { GetPageQuery } from "apollo"
import { BlockRenderer, CustomBreadcrumbs } from "ui"
import { findProperty, getBreadCrumbs } from "utils"
import { AbsoluteImageWithText } from "./AbsoluteImageWithText"

const StyledBreadCrumbsContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 40px;
    margin-bottom: 40px;
  }
`

type Props = {
  data: GetPageQuery
  locale: string
}
function DonationRequest({ data, locale }: Props) {
  const { selfObject, parents } = getBreadCrumbs(data, locale)
  const components = {
    imageTextBlock1: AbsoluteImageWithText,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []
  const hasBanner = blocks?.some(
    (block: any) => block.blockType === "topBanner" || block.blockType === "HeaderWithHeroAndText",
  )
  return (
    <>
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "contentText") {
          additionalProps = {
            hasBanner: hasBanner,
          }
        } else if (block.blockType === "numbersComponent1") {
          additionalProps = {
            accentColor: "black",
          }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            props={additionalProps}
          >
            {block.blockType === "imageTextBlock1" && (
              <StyledBreadCrumbsContainer>
                <CustomBreadcrumbs current={selfObject} parents={parents} />
              </StyledBreadCrumbsContainer>
            )}
          </BlockRenderer>
        )
      })}
    </>
  )
}

export default DonationRequest
